import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
const BudgetAllocationList = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const { sendRequest: getUser } = useHttp();

 const { sendRequest: getDataList } = useHttp();
 const [allData, setAllData] = useState([]);
 

 const { sendRequest: deleteHolidays } = useHttp();


  const deleteOperation = (e, data) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Holidays detail?",
      onOk() {
        const updatedApproveData = {
          ...data,
          status: 0,
        };

        deleteHolidays(
          {
            url: "/api/bankDetail/",
            method: "PUT",
            body: updatedApproveData,
          },
          (data) => {
            toast.success("Data deleted successfully");
            FillDetail();
          }
        );
      },
      onCancel() {},
    });
  };

   
  


  const FillDetail = () => {

    getDataList(
      {
        url: `/api/budgetApproval?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res);       
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getDataList]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  const handleSearch = (e) => {
  
    var filetrtext = e.target.value.trim().toLowerCase();
    //console.log(filetrtext);
    
        
    var filterdata=allData.filter(item => 
      (item?.accountGroupName?.includes(filetrtext )) 
      ||(item?.accountGroupcode?.includes(filetrtext))
      ||(item?.accountHead?.includes(filetrtext))
      ||(item?.accountSubGroupName?.includes(filetrtext))
      ||(item?.accountSubGroupCode?.includes(filetrtext))
      ||(item?.accountCode?.includes(filetrtext))
      ||(item?.accountName?.includes(filetrtext))

      
    );
      
 
     setData(filterdata)
  };
  

  
  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
       
        <div className="col-6"><label className="card-title mx-2 my-3"> &nbsp; &nbsp;Field Activity Budget Detail </label>   </div>
        <div className="col-3">     </div>
          <div className="col-3 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-2 my-2"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Field Activity Budget
            </button>
          </div>
          
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">

                  <div className="card-body">

                  <div className="row">   
                  <div className="col-4"> </div>
                  <div className="col-4"> </div>
                   
                  <div className="col-4"> <input type="text" name="q" className="form-control"    onKeyUp={(e) => {
                  handleSearch(e);
                 
                }} placeholder="Search..."/> </div>
                      </div>
                  <div className="row"> 
                  <table className="table table-bordered table-responsive text-center table-sm">
                    <thead>
                        
                        <tr>
                        <th>Doc No</th>
                <th>Start Date</th>
                
                <th>Plot Name</th>
                <th>Crop Name</th>
                <th>Variety </th>
                <th>Area </th>
                <th>Farm Manager </th>
            
                <th>From Date</th> 
                      <th>To Date</th> 
                      <th>Approved Budget</th> 

                      <th>Created By </th>
                          <th>Edit</th>
                          <th>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                {currentItems &&
                  currentItems.map((itm,i) => (
                    <tr key={i}>

<td>{itm.budgetApprovalNo}</td>
                      <td>{itm.budgetApprovalDate}</td>
                      

                      <td>{itm.plotName}</td>
                      <td>{itm.cropName}</td>
                      <td>{itm.varietyName}</td>
                      
                      <td>{itm.activityArea}
                      {itm.activityAreaUnit}</td> 
                      <td>{itm.farmManager}</td>

                      <td>{itm.fromDate}</td> 
                      <td>{itm.toDate}</td> 
                      <td>{itm.approvedBudget}</td> 

                      <td>{itm.createdByName}</td> 
                      <td>
                        <button className="btn"  onClick={() => {
                            props.update(itm);
                            props.addForm(true);
                          }}> <i className="fas fa-edit"></i></button>
                      </td>
                      <td>
                        <button className="btn"  onClick={(e) => deleteOperation(e, itm)} > <i className="fas fa-trash"></i></button>
                      </td>
                    </tr>
                  ))}
              </tbody>


                       
                    </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default BudgetAllocationList;